import React from 'react';
import clsx from 'clsx';

import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';

import GridIcon from '../../../../../Icons/icons/GridIcon';
import StackedBoxes from '../../../../../Icons/icons/StackedBoxes';
import { useCampaignDetail } from '../CampaignDetailProvider';

const ViewSelect = () => {
  const { selectedView, setSelectedView, clearAllContentFilters } = useCampaignDetail();

  return (
    <div className="sl-view-select-container">
      <CustomTooltip title="Grid View" placement="bottom">
        <div
          className={clsx('sl-view-option', { 'sl-view-option-selected': selectedView === 'grid' })}
          onClick={() => {
            setSelectedView('grid');
            clearAllContentFilters();
          }}>
          <GridIcon color="currentColor" />
        </div>
      </CustomTooltip>
      <div className="sl-header-divider" />
      <CustomTooltip title="List View" placement="bottom">
        <div
          className={clsx('sl-view-option', { 'sl-view-option-selected': selectedView === 'list' })}
          onClick={() => {
            setSelectedView('list');
            clearAllContentFilters();
          }}>
          <StackedBoxes width={20} height={20} color="currentColor" strokeWidth={2} />
        </div>
      </CustomTooltip>
    </div>
  );
};

export default ViewSelect;
